import { createContext } from "react";

const DashboardContext = createContext('portfolio')

export default DashboardContext